import { render, staticRenderFns } from "./ProjectShellTopBar.vue?vue&type=template&id=ffd296a2&scoped=true"
import script from "./ProjectShellTopBar.vue?vue&type=script&lang=ts"
export * from "./ProjectShellTopBar.vue?vue&type=script&lang=ts"
import style0 from "./ProjectShellTopBar.vue?vue&type=style&index=0&id=ffd296a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd296a2",
  null
  
)

export default component.exports